import { useEffect, useState } from "react";

const StarFilledIcon = ({ className, fill = "#FFC107" }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 19 19"
      className={_class}
    >
      <path d="M9.07303 0.124803C9.16947 -0.0407634 9.40866 -0.0407634 9.50509 0.124803L12.4664 5.20912C12.5018 5.26977 12.561 5.31277 12.6296 5.32763L18.3801 6.5729C18.5674 6.61345 18.6413 6.84093 18.5136 6.9838L14.5933 11.3713C14.5465 11.4237 14.5239 11.4933 14.531 11.5631L15.1237 17.417C15.143 17.6077 14.9495 17.7483 14.7741 17.671L9.38988 15.2983C9.32565 15.27 9.25248 15.27 9.18825 15.2983L3.80399 17.671C3.62865 17.7483 3.43515 17.6077 3.45445 17.417L4.04715 11.5631C4.05422 11.4933 4.03161 11.4237 3.98485 11.3713L0.0644855 6.9838C-0.0631781 6.84093 0.010735 6.61345 0.197998 6.5729L5.94857 5.32763C6.01717 5.31277 6.07636 5.26977 6.11169 5.20912L9.07303 0.124803Z" fill={fill}/>
    </svg>
  );
};

export default StarFilledIcon;
